import React from "react";

function VisaIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24 24H0V0H24V24Z" stroke="#667085" />
      <path
        d="M20 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5Z"
        stroke="#424242"
        strokeWidth="1.81981"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 10.0039H22"
        stroke="#424242"
        strokeWidth="1.81981"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default VisaIcon;
